import { Automotriz } from "../../components";
import "./stylesCategoriaAutomotriz.scss";

export const CategoriaAutomotriz = () => (
  <div>
    <Automotriz />
  </div>
);
